import { render, staticRenderFns } from "./FormType.vue?vue&type=template&id=d8272ab2&scoped=true&"
import script from "./FormType.vue?vue&type=script&lang=js&"
export * from "./FormType.vue?vue&type=script&lang=js&"
import style0 from "./FormType.vue?vue&type=style&index=0&id=d8272ab2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8272ab2",
  null
  
)

export default component.exports